import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { appStyles, logoImage } from './app.style';
import { useAuth } from '../auth/AuthContext';
import { apiLogin } from '../data/api';
import { Role, Status } from '../data/types/medico.types';
import { LoginStatus } from './loginApp.types';
import { LinkInApp } from './LinkInApp.component';
import { ContainerApp, ContentApp, HeaderApp, LabelApp } from './Layout.app';
import { Spinner } from '../components/spinner/Spinner.component';
 
export const LoginApp = () => {
  const [dni, setDni] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login, logout } = useAuth();
  const [ modo, setModo ] = useState<'login' | 'check'>('check');
  const navigate = useNavigate();
 
  useEffect(() => {
	logout()
  }, [])
 
  const handleSubmit = async (e: React.FormEvent) => {
	e.preventDefault();
	setIsLoading(true);
	setError('');
 
	if (modo === 'check') {
		try {
			// TODO: Mover esto a un lugar mas apropiado...
			const {data: loginResponse} = await apiLogin.get(`/api/authp/check/${dni}`);
		
			const token = loginResponse.role === Role.PACIENTE ? loginResponse.token : undefined
		
			login( token, `${loginResponse.nombre} ${loginResponse.apellido}`, loginResponse.role);
			
			if (loginResponse.loginStatus === LoginStatus.NUEVO) navigate(`/app/register/${dni}`)
			if (loginResponse.loginStatus === LoginStatus.EXISTENTE) setModo('login')

		} catch (err) {
			console.log("### error", err)
			setError('Credenciales incorrectas');
		} finally {
			setIsLoading(false);
		}
	} else {
		try {
			// TODO: Mover esto a un lugar mas apropiado...
			const {data: loginResponse} = await apiLogin.post(`/api/authp/login`, { dni, password });
		
			await login( loginResponse.token, `${loginResponse.nombre} ${loginResponse.apellido}`, Role.PACIENTE);
			
			if (loginResponse.hayPendientes || loginResponse.hayTurnosPasados) navigate(`/app/menu`, {
				state: {
					hayPendientes: loginResponse.hayPendientes,
					hayTurnosPasados: loginResponse.hayTurnosPasados,
				}
			})
			else navigate(`/app/wizard`)

		} catch (err) {
			console.log("### error", err)
			setError('Credenciales incorrectas');
		} finally {
			setIsLoading(false);
		}
	}
  };
 
  if (isLoading) return <Spinner />

  return (
	<ContainerApp>
		<HeaderApp title="Identificación" />
		<ContentApp>
			<form onSubmit={handleSubmit}>
			<LabelApp label="Número de DNI" />
			<input
				type="text"
				placeholder="DNI"
				style={{...appStyles.input}}
				value={dni}
				onChange={(e) => setDni(e.target.value)}
				required
			/>
			{modo === 'login' && <>
				<LabelApp label="Pin" />
				<input
					type="password"
					placeholder="Ingrese elPin"
					style={appStyles.input}
					value={password}
					onChange={(e) => setPassword(e.target.value)}
					required
				/>
			</>}
			
				<button 
					type="submit" 
					style={appStyles.button}
					disabled={isLoading}
				>
					{isLoading ? (
					<div style={appStyles.loader} />
					) : (
					'Continuar'
					)}
				</button>
		
				{error && <p style={appStyles.error}>{error}</p>}

				<div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'right', alignItems: 'center', gap: '1rem' }}>
				<LinkInApp 
					label="Olvidé la contraseña"
					onClick={() => navigate('/app/forgot-pass/generate')}
				/>
				</div>
			</form>
		</ContentApp>
 
	</ContainerApp>
  );
};
